import { observer } from 'mobx-react-lite'
import { useLoaderData } from 'react-router'
import { useActivation } from '@/hooks/view-model-hooks'
import {
  CompleteRegistration,
  CompleteRegistrationError,
} from '@/features/iam/auth/CompleteRegistration'
import { ContentError } from '@/components/ContentError'
import { ContentLoading } from '@/components/ContentLoading'
import type { CompleteRegistrationViewModel } from '@/features/iam/auth/CompleteRegistration/CompleteRegistrationViewModel'
import { PasswordResetContainer } from '@/features/iam/auth/PasswordReset/PasswordResetContainer'

export const CompleteRegistrationContainer = observer(
  function CompleteRegistrationContainer() {
    // The route loader returns the view model for the route's token.
    const { vm } = useLoaderData<{ vm: CompleteRegistrationViewModel }>()

    useActivation(vm)

    return vm.fetch.match({
      pending: () => <ContentLoading />,
      rejected: (err) => (
        <CompleteRegistrationError>
          <ContentError error={err} />
        </CompleteRegistrationError>
      ),
      resolved: () => (
        <CompleteRegistration>
          <PasswordResetContainer vm={vm.passwordResetVm} />
        </CompleteRegistration>
      ),
    })
  },
)
